import React, { PureComponent } from 'react'
import { Pane, Link, Text, Dialog } from 'evergreen-ui'

export default class URLHelp extends PureComponent {

    render() {
        const { whereModal } = this.props;
        return (
            <Dialog
                title="Where to find the URL?"
                isShown={whereModal}
                onCloseComplete={() => this.setState({ whereModal: false })}
                hasFooter={false}
                width={600}
                height={"75vh"}
                padding={25}>
                <Pane>
                    <Pane marginBottom={10}><Text size={600}>RTSP</Text></Pane>
                    <Pane>
                        <Text>Find your model on this </Text>
                        <Link href={"https://community.geniusvision.net/platform/cprndr/manurtsplist"} rel="noopener noreferrer" target="_blank">
                            <Text> website </Text>
                        </Link>
                        <Text> or </Text>
                        <Link href={"https://www.ispyconnect.com/man.aspx"} rel="noopener noreferrer" target="_blank">this one</Link>
                        <Pane><Text>Replace the IP address with yours.</Text></Pane></Pane>
                </Pane>

                <Pane marginTop={30}>
                    <Pane marginBottom={10}><Text size={600}>M-JPEG</Text></Pane>
                    <Pane>
                        <Text>Right click on the image and click copy image url. </Text>
                    </Pane>
                    <Pane>
                        <Link href={"https://youtu.be/-UugUHp2Vqg"} rel="noopener noreferrer" target="_blank">
                            <Text>Video showing how to get it.</Text>
                        </Link>
                    </Pane>
                </Pane>

            </Dialog>
        )
    }

}